import React, {Component} from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import { I18n } from 'react-i18next';

import { resetGa } from "../../../../../01-actions/user";
import validate from './validate';
import SubmitButton from '../../../../../03-components/ModalSubmitButton/index';

class ResetGa extends Component {
	state = {
		resetCode: '',
		password: '',
	};

	componentWillReceiveProps(nextProps) {
		if (nextProps.gaReset && nextProps.gaReset !== this.props.gaReset) {
			this.props.refreshInputAndToggle();
		}
	}

	renderField = ({ input, label, type, value, meta: { touched, error } }) => (
		<div className="form-group">
			<label>{label}</label>
			<div className="input-group">
				<input
					{...input}
					type={type}
					className="form-control transfer-input"
					value={value}
					onChange={e => this.setState({ [input.name]: e.target.value })}
				/>
				{touched && error && <p className="text-danger">{`* ${error}`}</p>}
			</div>
		</div>
	);

	resetGA = () => {
		const { resetCode, password } = this.state;
		this.props.actions.resetGa({ resetCode, password });
	};

	refreshInputAndToggle = () => {
		this.setState({ resetCode: '', password: '' });
		this.props.toggle();
	};
	
	render() {
		const {
			isOpen,
			invalid,
			gaResetting,
		} = this.props;

		const  {
		    password,
            resetCode
        } = this.state

		return (
			<I18n ns="translations">
				{
					t => (
						<Modal isOpen={isOpen} className="modal-lg">
							<ModalHeader toggle={this.refreshInputAndToggle}>{t('two_factor_authentication_reset')}</ModalHeader>
							<ModalBody>
								<div className="change-password-attention">
									<p>{t('attention_')}</p>
									<p>{t('reset_ga_intro')}</p>
								</div>
								<form className="margin-top-1rem">
									<Field
										name="resetCode"
										type="text"
										component={this.renderField}
										label={t('ga_reset_code')}
									/>
									<Field
										name="password"
										type="password"
										component={this.renderField}
										label={t('password')}
									/>
								</form>
							</ModalBody>
							<ModalFooter>
								<SubmitButton
									className="btn btn-primary"
									onClick={this.resetGA}
									isSubmitting={gaResetting}
									disabled={invalid || !password || !resetCode}
									text={t('reset_')}
								/>
							</ModalFooter>
						</Modal>
					)
				}
			</I18n>
		);
	}
}

const mapStateToProps = store => {
	return {
		gaReset: store.user.gaReset,
		gaResetting: store.user.gaResetting,
	};
};

const mapDispatchToProps = dispatch => {
	return {
		actions : bindActionCreators(
			{
				resetGa,
			},
			dispatch
		)
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps,
)(reduxForm({
	form: 'resetGa',
	validate,
})(ResetGa));
